import { render, staticRenderFns } from "./DashboardNavbar.vue?vue&type=template&id=a3bda7d2&scoped=true"
import script from "./DashboardNavbar.vue?vue&type=script&lang=ts"
export * from "./DashboardNavbar.vue?vue&type=script&lang=ts"
import style0 from "./DashboardNavbar.vue?vue&type=style&index=0&id=a3bda7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bda7d2",
  null
  
)

export default component.exports